import React, { useContext } from "react"
import LocaleContext from "../../context/LocaleContext"
import translate, { keys } from "../../translation/translator"
import Styles from "./styles/ForDiabetesSectionStyle.module.styl"

const ForDiabetesSection = () => {
  const locale = useContext(LocaleContext).locale
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.content}>
        <h2 className={Styles.title}>
          {translate(keys.INDEX_DIABETES_DESC, locale)}
        </h2>
        <div className={Styles.features}>
          <div className={Styles.feature}>
            <p className={Styles.percentage}>
              {translate(keys.INDEX_DIABETES_AFFECTED_COUNT, locale)}
            </p>
            <p className={Styles.text}>
              {translate(keys.INDEX_DIABETES_AFFECTED, locale)}
            </p>
          </div>
          <div className={Styles.feature}>
            <p className={Styles.percentage}>
              {translate(keys.INDEX_DIABETES_DEAD_COUNT, locale)}
            </p>
            <p className={Styles.text}>
              {translate(keys.INDEX_DIABETES_DEAD, locale)}
            </p>
          </div>
          <div className={Styles.feature}>
            <p className={Styles.percentage}>
              {translate(keys.INDEX_DIABETES_SUGAR_DEAD, locale)}
            </p>
            <p className={Styles.text}>
              {translate(keys.INDEX_DIABETES_SUGAR, locale)}
            </p>
          </div>
          <div className={Styles.feature}>
            <p className={Styles.percentage}>
              {translate(keys.INDEX_DIABETES_DIAGNOSED_COUNT, locale)}
            </p>
            <p className={Styles.text}>
              {translate(keys.INDEX_DIABETES_DIAGNOSED, locale)}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForDiabetesSection
